<template>
	<div class="input-wrapper">
		<label
			v-if="labelText"
			class="label form-label"
		>
			{{ labelText }}
		</label>
		<textarea
			v-model.trim="fieldInput"
			rows="4"
			class="input form-control"
			:class="{
				'input--error': v$.fieldInput.$error,
			}"
			@blur="handleBlur"
			@input="handleInput"
		/>
		<p
			v-if="v$.fieldInput.$error"
			class="error-text"
		>
			{{ errorText }}
		</p>
	</div>
</template>
<script>
import { useVuelidate } from '@vuelidate/core';
import { minLength, requiredIf } from '@vuelidate/validators';

export default {
	props: {
		labelText: {
			type: String,
			default: '',
		},
		required: {
			type: Boolean,
			default: false,
		},
		manualInputDirtier: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['field-input'],
	data() {
		return {
			v$: useVuelidate(),
			fieldInput: '',
		};
	},
	computed: {
		errorText() {
			return 'Please enter details of what you would like to discuss';
		},
	},
	methods: {
		handleInput() {
			this.$emit('field-input', {
				value: this.fieldInput,
				isValid: (!this.v$.fieldInput.$invalid && this.fieldInput.length > 0),
			});
		},
		handleBlur() {
			this.v$.fieldInput.$dirty = true;
		},
	},
	watch: {
		manualInputDirtier(newValue, oldValue) {
			if (newValue) {
				this.v$.fieldInput.$dirty = true;
			}
		},
	},
	validations() {
		return {
			fieldInput: {
				required: requiredIf(this.required),
				minLength: minLength(2),
			},
		};
	},
};
</script>
